(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wonderful-baby-bot"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',()=>{

  const demoKey='wbb-demo-state-v1';
  const defaultDemo={role:'mom',carePackSent:false,wipesLow:false,events:[],summarySent:false,plan:'free'};
  let demoState;
  try{demoState=JSON.parse(localStorage.getItem(demoKey))||{...defaultDemo};}catch(e){demoState={...defaultDemo};}
  const saveDemo=()=>{try{localStorage.setItem(demoKey,JSON.stringify(demoState));}catch(e){}};
  const roleButtons=[...document.querySelectorAll('[data-wbb-role]')];
  const views=[...document.querySelectorAll('[data-wbb-view]')];
  const wipesEl=document.querySelector('[data-wbb-wipes]');
  const carepackEl=document.querySelector('[data-wbb-carepack]');
  const handback=document.querySelector('[data-wbb-handback]');
  const chips=document.querySelector('[data-wbb-summary-chips]');
  const eventLog=document.querySelector('[data-wbb-event-log]');
  const renderDemo=()=>{
    roleButtons.forEach(b=>b.classList.toggle('is-active',b.dataset.wbbRole===demoState.role));
    views.forEach(v=>v.hidden=v.dataset.wbbView!==demoState.role);
    if(wipesEl){wipesEl.textContent=demoState.wipesLow?'LOW':'GOOD';wipesEl.style.background=demoState.wipesLow?'#fff0f2':'#edf8f2';wipesEl.style.color=demoState.wipesLow?'#9b3039':'#287052';}
    if(carepackEl) carepackEl.textContent=demoState.carePackSent?'SENT':'READY';
    if(eventLog){
      eventLog.innerHTML=demoState.events.length?demoState.events.map(e=>'<span>'+e+'</span>').join(''):'<span>No care events logged yet.</span>';
    }
    document.querySelectorAll('[data-wbb-care-event]').forEach(b=>b.classList.toggle('is-logged',demoState.events.includes(b.dataset.wbbCareEvent)));
    if(handback){
      handback.hidden=!demoState.summarySent;
      if(chips) chips.innerHTML=demoState.events.map(e=>'<span>'+e+'</span>').join('');
    }
  };
  roleButtons.forEach(b=>b.addEventListener('click',()=>{demoState.role=b.dataset.wbbRole;saveDemo();renderDemo();}));
  document.querySelector('[data-wbb-send-care]')?.addEventListener('click',()=>{demoState.carePackSent=true;demoState.role='grandma';saveDemo();renderDemo();});
  document.querySelectorAll('[data-wbb-care-event]').forEach(b=>b.addEventListener('click',()=>{const e=b.dataset.wbbCareEvent;if(!demoState.events.includes(e))demoState.events.push(e);if(e==='WIPES LOW')demoState.wipesLow=true;saveDemo();renderDemo();}));
  document.querySelector('[data-wbb-finish-care]')?.addEventListener('click',()=>{demoState.summarySent=true;demoState.role='mom';saveDemo();renderDemo();});
  document.querySelector('[data-wbb-reset]')?.addEventListener('click',()=>{demoState={...defaultDemo,events:[]};saveDemo();renderDemo();});
  const planCopy={
    free:['FREE — Help me today.','Baby Now, Today, core Needs, basic handoff, Morning/Night and memory starter.'],
    power:['$2.99 POWER UP — Help me with this.','One focused premium assist: smarter packing, deeper needs check, Care Pack auto-prep, tomorrow planning or memory recap.'],
    pass:['$9.99 / 30 DAYS — Help me stay ahead.','More routine memory, multiple locations, recurring care prep, smarter packing and enhanced Baby Book planning.']
  };
  const previewOutput=document.querySelector('[data-wbb-preview-output]');
  document.querySelectorAll('[data-wbb-preview-plan]').forEach(b=>b.addEventListener('click',()=>{demoState.plan=b.dataset.wbbPreviewPlan;document.querySelectorAll('[data-wbb-preview-plan]').forEach(x=>x.classList.toggle('is-active',x===b));if(previewOutput){const p=planCopy[demoState.plan];previewOutput.innerHTML='<b>'+p[0]+'</b><span>'+p[1]+'</span>';}saveDemo();}));
  const talkBtn=document.querySelector('[data-wbb-talk]');
  const talkBox=document.querySelector('[data-wbb-talk-box]');
  const talkText=document.querySelector('[data-wbb-talk-text]');
  if(talkBtn&&talkBox&&talkText){
    talkBtn.addEventListener('click',()=>{
      talkBox.hidden=false;
      const SR=window.SpeechRecognition||window.webkitSpeechRecognition;
      if(!SR){talkText.textContent='Voice recognition is not supported in this browser. Try: “What do I need tonight?”, “Grandma”, or “Wipes”.';return;}
      const rec=new SR();rec.lang='en-US';rec.interimResults=false;rec.maxAlternatives=1;
      talkText.textContent='Listening…';
      rec.onresult=(ev)=>{
        const said=(ev.results[0][0].transcript||'').toLowerCase();
        if(said.includes('wipe')){demoState.wipesLow=true;talkText.textContent='I flagged wipes as needing attention. I’ll keep that visible for Mom.';}
        else if(said.includes('grandma')){talkText.textContent='Grandma is at 3 PM. Her Care Pack is '+(demoState.carePackSent?'already sent.':'ready to send.');}
        else if(said.includes('tonight')||said.includes('tomorrow')){talkText.textContent='Tonight: check wipes, pack the backup outfit, and confirm Grandma’s Care Pack.';}
        else{talkText.textContent='I heard: “'+said+'”. In the production version, BABY BOT will connect this to the family’s approved routines and data.';}
        saveDemo();renderDemo();
      };
      rec.onerror=()=>{talkText.textContent='I couldn’t hear that clearly. You can still use the buttons in this demo.';};
      rec.start();
    });
  }
  renderDemo();

  document.querySelectorAll('[data-wbb-open]').forEach(button=>{
    button.addEventListener('click',()=>{
      const dialog=document.querySelector('[data-wbb-dialog="'+button.dataset.wbbOpen+'"]');
      if(dialog) dialog.showModal();
    });
  });
  document.querySelectorAll('[data-wbb-close]').forEach(button=>button.addEventListener('click',()=>button.closest('dialog').close()));
  const next=document.querySelector('[data-wbb-next]');
  const handoff=document.querySelector('.wbb__handoff');
  if(next&&handoff){next.addEventListener('click',()=>{handoff.hidden=false;next.hidden=true;});}
  const send=document.querySelector('[data-wbb-send]');
  const sent=document.querySelector('.wbb__sent');
  if(send&&sent){send.addEventListener('click',()=>{sent.hidden=false;send.disabled=true;send.textContent='SENT TO GRANDMA ✓';});}
});

  } catch(e) { console.error(e); }
})();
})();
